import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Link } from "gatsby"
import ArrowLeftStroke from "@zendeskgarden/svg-icons/src/16/arrow-left-stroke.svg"
import { Media } from "../../lib/media-queries"
import SidebarAccordion from "./sidebarAccordion"
import SidebarLinkList from "./sidebarLinkList"
import { sidebarDataNodeShape, collections } from "../../lib/prop-types"

const Container = styled.div`
  min-height: 100%;
  overflow: hidden;
  color: ${props => props.theme.colors.sidebar.foreground};
  font-size: ${props => props.theme.fontSizes.md};
  background-color: ${props => props.theme.colors.sidebar.background};
`

const SidebarColumn = styled.div`
  padding: ${props =>
    `${props.theme.space.base * 16}px ${props.theme.space.sm}`};
`

const HomeLink = styled(Link)`
  display: flex;
  align-items: center;
  margin: ${props => `auto ${props.theme.space.horz.sm}`};
  color: ${props => props.theme.colors.sidebar.foreground};
  font-weight: ${props => props.theme.fontWeights.semibold};
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.colors.sidebar.foreground};
  }

  &:focus {
    box-shadow: ${props => props.theme.focusBoxShadow};
  }
`

const HomeArrow = styled(ArrowLeftStroke)`
  margin-right: ${props => props.theme.space.xs};
`

const Sidebar = ({
  data,
  breadcrumbs,
  collection,
  currentPage,
  isTopLevel
}) => {
  const renderSidebarContents = linkData => (
    <nav aria-label="Sidebar navigation" role="navigation">
      {!isTopLevel && (
        <HomeLink
          data-testid="dev-docs-sidebar-home-link"
          to={collection ? `/${collection}` : "/"}
        >
          <HomeArrow /> Home
        </HomeLink>
      )}
      <ul>
        <SidebarLinkList
          data={linkData}
          currentPage={currentPage}
          isTopLevel={isTopLevel}
        />
      </ul>
    </nav>
  )

  const contents = renderSidebarContents(data)

  return (
    <Container data-testid="dev-docs-sidebar-container">
      <Media lessThan="lg">
        <SidebarAccordion breadcrumbs={breadcrumbs}>
          {contents}
        </SidebarAccordion>
      </Media>
      <Media greaterThanOrEqual="lg">
        <SidebarColumn data-testid="dev-docs-sidebar-sidebar-column">
          {contents}
        </SidebarColumn>
      </Media>
    </Container>
  )
}

Sidebar.propTypes = {
  data: sidebarDataNodeShape.isRequired,
  breadcrumbs: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentPage: PropTypes.string,
  isTopLevel: PropTypes.bool,
  collection: collections
}

Sidebar.defaultProps = {
  collection: null,
  currentPage: null,
  isTopLevel: false
}

export default Sidebar
